import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "flex justify-end" }

import { computed, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { required } from '@vuelidate/validators';

import { useLoginMutation } from '@/entities/security/hooks';

import {
  NkStack,
  NkForm,
  NkFormItem,
  NkInputText,
  NkContainer,
  NkHeading,
  NkCenter,
  NkButton,
  NkIcon,
} from '@/core/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkLogin',
  setup(__props) {

const route = useRoute();

const getFlashParameters = computed(() => {
  if (route.params.flashMessage) {
    return JSON.parse((route.params.flashMessage as string));
  }

  return false;
});

const form = ref();

const rules = {
  username: { required },
  password: { required },
};

const fields = reactive({
  username: '',
  password: '',
});

const { mutate, error, isError, isLoading } = useLoginMutation();

const submit = () => {
  form.value.validator.$validate()
    .then((valid: boolean) => {
      if (valid) mutate(fields);
    });
};

return (_ctx: any,_cache: any) => {
  const _component_ElAlert = _resolveComponent("ElAlert")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(NkContainer), {
    size: "sm",
    class: "py-64"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NkStack), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NkForm), {
            ref_key: "form",
            ref: form,
            rules: rules,
            fields: fields
          }, {
            header: _withCtx(() => [
              (_unref(getFlashParameters))
                ? (_openBlock(), _createBlock(_component_ElAlert, {
                    key: 0,
                    type: _unref(getFlashParameters).type,
                    "show-icon": ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getFlashParameters).message), 1)
                    ]),
                    _: 1
                  }, 8, ["type"]))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_ElAlert, {
                "show-icon": "",
                type: "error"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(error)?.response?.data?.message || _unref(error)), 1)
                ]),
                _: 1
              }, 512), [
                [_vShow, _unref(isError)]
              ]),
              _createVNode(_unref(NkCenter), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkHeading), { type: "small-bold" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('misc.login')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            footer: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_unref(NkButton), {
                onClick: submit,
                icon: "NkLogin"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('actions.submit')), 1)
                ]),
                _: 1
              })), [
                [_directive_loading, _unref(isLoading)]
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(NkFormItem), {
                label: _ctx.$t('user.form.label.email'),
                prop: "username"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkInputText), {
                    name: "username",
                    modelValue: fields.username,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fields.username) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(NkFormItem), {
                label: _ctx.$t('user.form.label.password'),
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkInputText), {
                    type: "password",
                    name: "password",
                    modelValue: fields.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fields.password) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_router_link, {
                  class: "text-xxs transition hover:text-primary flex gap-1",
                  to: {name: 'security-forgotten-password'}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('user.form.label.forgotten_password')) + " ", 1),
                    _createVNode(_unref(NkIcon), {
                      name: "NkPrivacyTip",
                      size: 4
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["fields"])
        ]),
        _: 1
      })
    ]),
    _: 1
  })), [
    [_directive_loading, _unref(isLoading)]
  ])
}
}

})